<template>
  <div
    class="group size-full flex items-center justify-center cursor-pointer relative overflow-hidden rounded-inherit"
    @click="handleClick"
  >
    <img
      v-if="icon"
      :class="[botClass]"
      :style="style"
      :src="`/assets/img/avatar/${icon}.png`"
    />
    <div
      v-if="showEditMask"
      class="absolute inset-0 bg-mask-bg flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity rounded-full"
      aria-hidden
    >
      <BotIcon name="edit-line" :size="24" :padding="0" color="white" />
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import BotIcon from '@C/BotIcon.vue';

export default defineComponent({
  name: 'AgentAvatar',
  components: { BotIcon },
  props: {
    edit: {
      type: Boolean,
      default: false
    },
    icon: {
      type: [String, Number],
      default: ''
    },
    botClass: {
      type: String,
      default: ''
    },
    style: {
      type: Object,
      default: () => ({})
    },
    showEditMask: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(props, { emit }) {
    const handleClick = () => {
      emit('click');
    };

    return {
      handleClick
    };
  }
});
</script>
